<template>
    <div class="page-news page-content" v-loading="body_loading">
        <div class="main-body">
            <el-row class="hd">
                <el-col :span="12">
                    <h3 style="float: none;">官网新闻</h3>
                    <div class="flex-block breadcrumb-box">
                        <div class="position-text">位置：</div>
                        <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item>新闻管理</el-breadcrumb-item>
                            <el-breadcrumb-item>官网新闻</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </el-col>
                <el-col :span="12" class="text-right" style="padding: 11px 24px 11px 0;">
                    <el-button type="primary" class="btn-bg-p" @click="handleNews('add')">添加 <i class="el-icon-plus"></i></el-button>
                    <el-button type="primary" class="btn-bg-r" @click="delmultiple()">批量删除</el-button>
                </el-col>
            </el-row>
            <div class="bd">
                <div class="table-block content-body">
                    <div ref="contentBody">
                        <el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading" tooltip-effect="dark" style="width: 100%;text-align: center;" @selection-change="handleSelectionChange">
                            <el-table-column type="selection" width="55"></el-table-column>
                            <el-table-column prop="id" width="55" label="ID" align="center"></el-table-column>
                            <el-table-column prop="title" align="center" label="新闻标题" min-width="220">
                                <template slot-scope="scope">
                                    <my-textEllipsis v-if="is_refresh" :content="scope.row.title"></my-textEllipsis>
                                </template>
                            </el-table-column>
                           <!-- <el-table-column prop="intro" align="center" label="新闻简介" min-width="180">
                                <template slot-scope="scope">
                                    <my-textEllipsis v-if="is_refresh" :content="scope.row.intro"></my-textEllipsis>
                                </template>
                            </el-table-column>-->
                            <el-table-column prop="create_admin_name" align="center" label="创建人" min-width="120">
                            </el-table-column>
                            <el-table-column prop="edit_admin_name" align="center" label="修改人" min-width="120">
                            </el-table-column>
                            <el-table-column prop="read_count" align="center" label="浏览量" min-width="120">
                            </el-table-column>
                            <!--<el-table-column prop="image_url" align="center" label="封面图片" min-width="160">
                                <template slot-scope="scope">
                                    <img class="cursor" :src="baseUrl + scope.row.image_url" height="23" @click="dlg_preview.img_url = baseUrl + scope.row.image_url;dlg_preview.visible = true;" title="点击查看" />
                                </template>
                            </el-table-column>-->
                            <el-table-column prop="m_time" align="center" label="修改时间" min-width="180">
                            </el-table-column>
                            <el-table-column prop="c_time" align="center" label="创建时间" min-width="180">
                            </el-table-column>
                            <el-table-column prop="status_name" align="center" label="状态" min-width="120">
                                <template slot-scope="scope">
                                    <span :class="'status-'+scope.row.status">{{scope.row.status_name}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="operating" align="center" label="操作" min-width="140" fixed="right">
                                <template slot-scope="scope">
                                    <el-button class="option-btn btn-bd-s" type="primary" size="mini" @click="handleNews('edit',scope.row)">编辑</el-button>
                                    <el-button class="option-btn btn-bd-r" type="primary" size="mini" @click="deleteNews(scope.row.id)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="table_data.page_info.page"
                            :page-sizes="[10,30, 50,80,100]"
                            :page-size="table_data.page_info.pageSize"
                            layout="total, sizes, prev, pager, next"
                            :total="table_data.page_info.total">
                    </el-pagination>
                </div>
            </div>
        </div>
        <el-dialog class="dialog-export news-dialog" :title="dlg_news.title" :visible.sync="dlg_news.visible" width="1000px" @closed="closeNews" :close-on-click-modal="false">
            <el-form ref="formNews" :model="dlg_news.form" label-width="120px" :rules="dlg_news.rules" @submit.native.prevent>
                <el-form-item prop="title" label="新闻标题：" :error="dlg_news.error.title">
                    <el-input size="small" v-model="dlg_news.form.title" placeholder='请输入新闻标题' clearable></el-input>
                </el-form-item>
                <!--<el-form-item prop="intro" label="新闻简介：" :error="dlg_news.error.intro">
                    <el-input v-model="dlg_news.form.intro" type="textarea" :rows="3" size="small" placeholder="请输入新闻简介" clearable></el-input>
                </el-form-item>-->
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item prop="sort" label="排序：" :error="dlg_news.error.sort">
                            <el-input size="small" type='number' v-model="dlg_news.form.sort" placeholder='请输入排序（输入数字）' clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item prop="status" label="状态：" :error="dlg_news.error.status">
                            <el-radio-group v-model="dlg_news.form.status">
                                <el-radio v-for="(item, index) in dlg_news.init_data.status_list" :key="index" :label="item.id">{{item.name}}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
                <div><my-editor ref="editor" :content_text.sync="editor_content"></my-editor></div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dlg_news.visible = false">取 消</el-button>
                <el-button type="primary" @click="submitNews()" :loading="dlg_news.btn_loading">确认</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        name: 'usercenter',
        data() {
            return {
                clientHeight:'',
                body_loading:false,
                is_refresh: true,
                baseUrl:this.$client.IMG_URL,
                multipleSelection: [],
                table_data:{
                    loading: false,
                    list:[],
                    page_info: {
                        page: 1,
                        pageSize: 30,
                        total: 130
                    }
                },
                editor_content:'',
                dlg_news:{
                    id:'',
                    visible:false,
                    btn_loading:false,
                    api: '',
                    title:'',
                    init_data:{
                        status_list: []
                    },
                    form:{
                        title:'',
                        intro:'',
                        content:'',
                        sort:'',
                        status:1
                    },
                    error:{
                        title:'',
                        intro:'',
                        sort:'',
                        status:''
                    },
                    reset_form: {},
                    rules:{
                        title:{required: true, message: '请输入新闻标题', trigger: ['change','blur']},
                        intro:{required: true, message: '请输入新闻简介', trigger: ['change','blur']},
                        sort:{required: true, message: '请输入排序（输入数字）', trigger: ['change','blur']},
                        status:{required: true, message: '请选择状态', trigger: ['change','blur']}
                    }
                }
            }
        },
        created() {
            document.title = '官网新闻';
            this.dlg_news.reset_form = Object.assign({}, this.dlg_news.form);
            this.getList();
        },
        methods: {
            searchList(){
                var _this = this;
                _this.table_data.page_info.page = 1;
                _this.getList();
            },
            getList() {
                var _this = this;
                var params = {};
                params.p = _this.table_data.page_info.page;
                params.pageSize = _this.table_data.page_info.pageSize;
                var status_default = [{id:-1, name: '全部'}];
                _this.table_data.loading = true;
                this.$client.get('/adminapi/new/list', params, function(res,message){
                    _this.table_data.list = res.list;
                    _this.table_data.page_info = res.pager;
                    _this.dlg_news.init_data.status_list = res.status_name_list;
                    _this.table_data.loading = false;
                },function(res){
                    _this.table_data.loading = false;
                });
            },
            handleSizeChange(val) {
                //console.log(`每页 ${val} 条`);
                this.table_data.page_info.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                //console.log(`当前页: ${val}`);
                this.table_data.page_info.page = val;
                this.getList();
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            delmultiple(){
                var _this = this;
                var mullist = this.multipleSelection;
                if(mullist.length == 0){
                    _this.$message("请勾选需要删除的新闻");
                    return;
                }
                var idList = [];
                for(var i=0;i<mullist.length;i++){
                    idList.push(mullist[i].id);
                }
                var params = {id:idList.join(",")}
                this.$confirm('确定要批量删除？', "", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            iconClass:"icon-delete el-icon-delete",
                            customClass:"my-confirm-box",
                            center: true,
                        })
                        .then(() => {
                    _this.$client.post('/adminapi/new/delete', params, function(res,message){
                    _this.getList();
                },function(res){

                });
            })
            .catch(() => {});
            },
            handleNews(type,data){
                this.dlg_news.visible = true;
                if(type == 'add'){
                    this.dlg_news.title = '添加新闻';
                    this.dlg_news.api = '/adminapi/new/save';
                }else{
                    this.dlg_news.id= data.id;
                    this.dlg_news.title = '编辑新闻';
                    if(data){
                        for(var key in this.dlg_news.form){
                            this.dlg_news.form[key] = data[key];
                        }
                        this.editor_content = data.content;
                    }
                    this.dlg_news.api = '/adminapi/new/save?id=' + data.id;
                }
            },
            deleteNews(id){
                var _this = this;
                this.$confirm('确定要删除？', "", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            iconClass:"icon-delete el-icon-delete",
                            customClass:"my-confirm-box",
                            center: true,
                        })
                        .then(() => {
                    _this.$client.post('/adminapi/new/delete', {id:id}, function(res,message){
                    _this.getList();
                },function(res){

                });
            })
            .catch(() => {});
            },
            submitNews(){
                var _this = this;
                _this.$refs['formNews'].validate((valid) => {
                    if (valid) {
                        this.dlg_news.form.content = this.$refs.editor.content;
                        this.dlg_news.btn_loading = true;
                        this.$client.post(this.dlg_news.api, this.dlg_news.form, function(res,message){
                            //console.log(res)
                            _this.$message(message);
                            _this.getList();
                            _this.dlg_news.btn_loading = false;
                            _this.dlg_news.visible = false;
                        }, function(message){
                            //console.log(111)
                            _this.dlg_news.btn_loading = false;
                            if((typeof message)==='object'){
                                for(var key in message){
                                    _this.dlg_news.error[key] = message[key];
                                }
                            }
                        });
                    } else {
                        console.log('error submit!!');
                return false;
            }
            });
            },
            closeNews(){
                this.editor_content = '';
                this.dlg_news.btn_loading = false;
                for(var key in this.dlg_news.form){
                    this.dlg_news.form[key] = this.dlg_news.reset_form[key];
                }
                this.$nextTick(()=>{
                    this.$refs.formNews.clearValidate();
            })
            },
            changeFixed(clientHeight){
                this.$refs.contentBody.style.minHeight = (clientHeight-394)+'px';
            }
        },
        mounted(){
            // 获取浏览器可视区域高度
            this.clientHeight =   `${document.documentElement.clientHeight}`          //document.body.clientWidth;
            //console.log(self.clientHeight);
            window.onresize = function temp() {
                this.clientHeight = `${document.documentElement.clientHeight}`;
            };
        },
        watch: {
            // 如果 `clientHeight` 发生改变，这个函数就会运行
            clientHeight: function () {
                this.changeFixed(this.clientHeight)
            }
        }
    }
</script>
<style>
    .page-news .el-upload--picture-card{
        line-height: 80px;
    }
    .page-news .el-upload--picture-card,.el-upload-list--picture-card .el-upload-list__item{
        width: 80px;
        height: 80px;
    }
    .hide-upload .el-upload--picture-card {
        display: none;
    }
</style>
<style scoped>

</style>